import { EPortalStatus } from 'types/group';

// choose / preview 屏用的 provider 行数据：名单与邀请状态都来自 team-member listPage，
// 所以 Invited 是服务端状态（刷新后仍在），不是本地内存标记。
export type TSubmitProvider = {
    providerId: number;
    // team member id —— sendTeamMemberInvite 用的是它，不是 providerId
    memberId: number;
    name: string;
    initials: string;
    sub: string;
    invited: boolean;
};

export const isInvited = (portalStatus?: string) => !!portalStatus && portalStatus !== EPortalStatus.NOT_INVITED;

// 提交成功页的子屏：offer 卡背后的流程都在同一页里切，不走路由。
// marketplace offer 只有两条路——solo 进 preview，group 进 choose。
export type TSubmitScreen = 'home' | 'choose' | 'preview' | 'ehr';
